import { render } from "./ContactInformation.vue?vue&type=template&id=278cb578"
import script from "./ContactInformation.vue?vue&type=script&lang=ts"
export * from "./ContactInformation.vue?vue&type=script&lang=ts"
script.render = render

export default script